'use client';

import { EForceControDropdown } from './types.js';

var initialSearchBar = {
    keyword: '',
    isShow: false,
    forceControllDropdown: EForceControDropdown.JUST_SHOW_DROPDOWN_CONTENT,
    isLoaded: false,
    isBlurBackground: false,
    isInMobile: true,
    topJobItem: null,
    highlightJob: null,
    hotKeywords: [],
    suggestions: [],
    selectedSuggestionIndex: -1,
    isLockedDebounce: false,
    jobYouWillLove: [],
    searchJobYouLove: [],
    recentSearch: [],
    locations: []
};

export { initialSearchBar };
//# sourceMappingURL=index.js.map
